import { createSlice } from '@reduxjs/toolkit';
import { initialState, commonReducers } from './fileVersionHistory.slice';

const taxImportVersionHistorySlice = createSlice({
  name: 'taxImportVersionHistory',
  initialState,
  reducers: { ...commonReducers },
});

export default taxImportVersionHistorySlice.reducer;
export const {
  setOpenFileVersionHistory,
  setOpenDeleteVersionConfirmationModal,
  addToFileVersions,
  getNextVersions,
  deletedLastVersion,
} = taxImportVersionHistorySlice.actions;
